import { currentUserUpdatedType } from '@Containers/Header/HeaderComponentConstants';

// eslint-disable-next-line import/prefer-default-export
export function currentUserUpdated(currentUser) {
  return {
    type: currentUserUpdatedType,
    currentUser,
  };
}
